import { Component, Inject, NgZone, ViewEncapsulation } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
    templateUrl: './message-modal.html',
    styleUrls: ['./message-modal.css'],
    encapsulation: ViewEncapsulation.ShadowDom,
    standalone: false
})
export class MessageNoCSSModalComponent {
  title: string;
  message: string;
  closeWithZone: boolean = false;

  constructor(public dialogRef: MatDialogRef<MessageNoCSSModalComponent>, @Inject(MAT_DIALOG_DATA) data: any, private zone: NgZone) {
    this.title = data.title;
    this.message = data.message;
    this.closeWithZone = data.closeWithZone;
  }


  closeDialog()
  {
    if(this.closeWithZone)
    {
      this.zone.run(() => {
        this.dialogRef.close();
      });
    }
    else
    {
      this.dialogRef.close();
    }
    
  }
}
